import TodayIcon from '@mui/icons-material/Today'
import { Box, Typography } from '@mui/material'
import { DateField } from 'react-admin'

import { HeaderSection } from './AdvancedInfoWindow'
import FieldRow from './FieldRow'
import LocationField from './LocationField'

export const SpeedLimitBadge = ({ value }) => {
  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: '2.5px solid red',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        boxShadow: '0 1px 2px rgba(0,0,0,0.25)',
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: '0.7rem', lineHeight: 1, color: 'black' }}>{value}</Typography>
    </Box>
  )
}
const TelematicContextSection = () => (
  <>
    <HeaderSection title="context" />
    <FieldRow icon={TodayIcon}>
      <DateField source="captured_on" showTime />
    </FieldRow>
    <LocationField />
  </>
)

export default TelematicContextSection
